import {Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import { CommonModule } from "@angular/common";
import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormGroup, FormsModule} from "@angular/forms";
import {RoleService} from "../../../admin/data-access/role.service";

export interface DropdownSearch {
  name: string;
}
@Component({
  selector: 'dropdown-search',
  imports: [CommonModule, FontAwesomeModule, FormsModule],
  templateUrl: './dropdown-search.html',
  standalone: true,
  styleUrls: ['./dropdown-search.css']
})
export class DropdownSearchComponent implements OnInit, OnChanges {
  constructor(private roleService: RoleService) {
  }

  inputIsFocused = false;
  insideClick = false;
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  filteredItems: any[] = [];

  @Input('searchFilter') searchFilter = '';
  @Input('placeholder') placeholder: string = '';
  @Input('addedList') addedList: any[] = [];
  @Input('getRoleDetails') getRoleDetails: boolean = false
  @Input('items') items: any[] = [];
  @Input('singleItemList') singleItemList: boolean = false;
  @Input('isSubject') isSubject: boolean = false;
  @Input('isUnit') isUnit: boolean = false;
  @Input('isOrganization') isOrganization: boolean = false
  @Input('isCourse') isCourse: boolean = false
  @Input() selectedSubjectID: number = -1
  @Input() selectedCCLID: number = -1
  @Input('FormGroup') formGroup: FormGroup = new FormGroup({})
  @Input('disabled') disabled: boolean = false

  @Output() selectedCCLIDChange = new EventEmitter<number>()
  @Output() APIResponseFunction = new EventEmitter<Function>()
  @Output() singleItemChange = new EventEmitter<Function>()
  @Output() searchFilterChange = new EventEmitter<string>()
  @Output() selectedSubjectIDChange = new EventEmitter<number>()
  @Output() formGroupChange = new EventEmitter<FormGroup>()

  ngOnInit() {
    this.filteredItems = this.items;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['items']) {
      this.filteredItems = this.items;
    }
    if(this.singleItemList && changes['addedList'] && changes['addedList'].currentValue !== undefined) {
      if(changes['addedList'].currentValue.length > 0 && changes['addedList'].currentValue[0] !== undefined) {
        this.searchFilter = changes['addedList'].currentValue[0].name
      } else {
        this.searchFilter = ''
      }
    }
  }

  search(search: string) {
    if(search === '') {
      this.filteredItems = this.items;
    } else {
    this.filteredItems = this.items.filter(item =>
      item.name.toLowerCase().includes(search.toLowerCase())
    );
    }
  }

  select(item: any) {
    this.filteredItems = this.items;
    this.inputIsFocused = false;
    this.formGroup.markAsDirty()
    this.formGroupChange.emit()
    if(item.subject_id != null) {
      this.selectedSubjectIDChange.emit(item.subject_id)
      this.APIResponseFunction.emit(this.APIResponseFunction)
    }
    if(item.customcontentlayer_id != null) {
      this.selectedCCLIDChange.emit(item.customcontentlayer_id)
      this.APIResponseFunction.emit(this.APIResponseFunction)
    }
    if(!this.singleItemList) {
      this.addedList.push(item)
      this.APIResponseFunction.emit(this.APIResponseFunction)
    }
    else {
      this.searchFilter = item.name;
      this.addedList.splice(0, this.addedList.length)
      if(this.getRoleDetails) {
        this.roleService.getRoleScope(item.role_id).subscribe((response) => {
          this.addedList.push(
            {
              role_id: item.role_id,
              subjects: response.result.subjects,
              units: response.result.units,
              organizations: response.result.organizations,
              courses: response.result.courses
            })
        })
      }
      else
        this.addedList.push(item)
      this.singleItemChange.emit(this.singleItemChange)
    }
  }

  @HostListener('click') onClick() {
    this.insideClick = true
  }

  @HostListener('document:click') onClickOut() {
    if(!this.insideClick)
      this.inputIsFocused = false
    this.insideClick = false
  }

  findItemInAddedItems(item: any): boolean {
    const stringifiedList = this.addedList.map(item => JSON.stringify(item))
    return stringifiedList.find(option => option === JSON.stringify(item)) != undefined;
  }
}
